import { defineStore } from 'pinia'

export const useLoaderStore = defineStore('loader', {
  state: () => ({
    isLoading: false,
    loadingMessage: '',
  }),

  actions: {
    show(message = 'Loading...') {
      this.isLoading = true
      this.loadingMessage = message
    },

    hide() {
      this.isLoading = false
      this.loadingMessage = ''
    },
  },
}) 